import React from 'react';
import { 
  Box, 
  VStack, 
  Text, 
  Flex
} from '@chakra-ui/react';
import { NavLink, useLocation } from 'react-router-dom';

interface NavItemProps {
  label: string;
  to: string;
}

const NavItem: React.FC<NavItemProps> = ({ label, to }) => {
  const location = useLocation();
  const isActive = location.pathname.includes(to);
  
  const activeColor = 'blue.300';
  const activeBg = 'blue.900';
  const hoverBg = 'gray.700';

  return (
    <NavLink to={to} style={{ width: '100%' }}>
      <Flex
        align="center"
        p={3}
        mx={2}
        borderRadius="lg"
        cursor="pointer"
        bg={isActive ? activeBg : 'transparent'}
        color={isActive ? activeColor : 'inherit'}
        _hover={{ bg: isActive ? activeBg : hoverBg }}
        transition="all 0.2s"
      >
        <Text fontSize="sm" fontWeight={isActive ? 'semibold' : 'medium'} color={isActive ? activeColor : 'gray.300'}>
          {label}
        </Text>
      </Flex>
    </NavLink>
  );
};

const CloverSidebarSimple: React.FC = () => {
  return (
    <Box
      w="250px"
      h="100vh"
      bg="gray.800"
      borderRight="1px"
      borderColor="gray.700"
      py={6}
    >
      {/* Logo/Brand */}
      <Flex align="center" px={4} mb={8}>
        <Text fontSize="xl" fontWeight="bold" color="green.500">
          Clover
        </Text>
      </Flex>

      {/* Navigation */}
      <VStack spacing={1} align="stretch">
        <NavItem label="Dashboard" to="dashboard" />
        <NavItem label="Contacts" to="contacts" />
        <NavItem label="Invoices" to="invoices" />
        <NavItem label="Revenue" to="revenue" />
        <NavItem label="Templates" to="templates" />
        <NavItem label="System Health" to="health" />
      </VStack>

      {/* Footer */}
      <Box position="absolute" bottom={4} left={4} right={4}>
        <Text fontSize="xs" color="gray.400" textAlign="center">
          Clover Portal v1.0
        </Text>
      </Box>
    </Box>
  );
};

export default CloverSidebarSimple;